import { render, staticRenderFns } from "./userInfoCard.vue?vue&type=template&id=616669d8&scoped=true"
import script from "./userInfoCard.vue?vue&type=script&lang=js"
export * from "./userInfoCard.vue?vue&type=script&lang=js"
import style0 from "./userInfoCard.vue?vue&type=style&index=0&id=616669d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616669d8",
  null
  
)

export default component.exports